/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-03 17:55:25
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-28 13:17:20
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/multiLanguage/index.ts
 */
import {
  post, //remove,
  get,
} from 'src/tools/server';

const getLanguageList = (uuid) => {
  return get<any[]>(
    `/portal/salesChannelSetting/language/available/${uuid}`,
    {},
  );
};

const getSpecificLanguageList = (body) => {
  return post<any[]>(
    `/portal/salesChannelSetting/language/selection`,
    body,
    {},
  );
};

export { getLanguageList, getSpecificLanguageList };
